// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyNotificationsSiteSettingsPageLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NotificationsSiteSettingsPage" */ './site-settings/NotificationsSiteSettingsPage.tsx'
			)
		).NotificationsSiteSettingsPage,
});

export { ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE } from './site-settings/notificationsSiteSettingsAnalyticsSource.ts';
